import React from 'react';

// Styles
import { Container } from './styles';

// Components
import ForgotPasswordForm from '../../../components/forms/ForgotPasswordForm';

//Layouts
import CredentialsLayout from '../../../components/layouts/CredentialsLayout';

export default function ForgotPasswordPage() {
  return (
    <Container>
      <CredentialsLayout>
        <ForgotPasswordForm />
      </CredentialsLayout>
    </Container>
  );
}
